export default "__VITE_PUBLIC_ASSET__d402a30a__"